module.exports = __webpack_public_path__ + "static/story6-thumbnails-rect-250x125-1b942115c4999b3e2d21c0697fe27dae.jpg";